import React from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import "./GradeCard.css";

function GradeCard(props) {
  let gradeLevel = props.gradeLevel;
  let gradeLevel1 = props.gradeLevel1;
  let gradeLevel2 = props.gradeLevel2;
  let gradeLevel3 = props.gradeLevel3;
  let trialClass = props.trialClass;

  // Dynamic helper function to determine grade card class
  const getGradeCardClassName = () => {
    if (gradeLevel1) return "grade-level-blue";
    if (gradeLevel2) return "grade-level-purple";  
    if (gradeLevel3) return "grade-level-coral";
    return "grade-level-purple"; // fallback
  };

  return (
    <p className={getGradeCardClassName()}>
      {gradeLevel}
    </p>
  );
}

export default GradeCard;